import React, { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import swal from 'sweetalert';
import TableComponent from '../../shared/table';
import LoaderComponent from '../../shared/loader';
import { API_URL } from '../../shared/constant';

const InquiriesListComponent = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchList = async () => {
        try {
            setLoading(true);
            const res = await axios.post(API_URL.ADMIN_SETTING_INQUIRIES, {});
            if (res && res.data) {
                // assume API returns array in res.data.data or res.data
                const list = res.data.data ? res.data.data : res.data;
                setData(Array.isArray(list) ? list : []);
            }
        } catch (error) {
            console.error('Fetch inquiries error', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchList();
    }, []);

    const onView = (item) => {
        const contentEl = document.createElement('div');
        contentEl.style.whiteSpace = 'pre-wrap';
        contentEl.style.width = '90vw';
        contentEl.style.maxWidth = '1100px';
        contentEl.style.boxSizing = 'border-box';
        contentEl.style.padding = '10px';
        contentEl.innerHTML = `
            <div>
                ${item.message}
            </div>`;

        swal({
            title: 'Inquiry',
            content: contentEl,
            buttons: {
                ok: 'Close'
            }
        });
        // SweetAlert default modal has a max-width; override it after render
        setTimeout(() => {
            const modal = document.querySelector('.swal-modal');
            if (modal) {
                modal.style.maxWidth = '1100px';
                modal.style.width = '90vw';
            }
            const content = document.querySelector('.swal-content');
            if (content) {
                content.style.width = '100%';
            }
        }, 30);
    }

    const onDelete = async (item) => {
        try {
            const res = await axios.post(API_URL.ADMIN_SETTING_INQUIRIES_DELETE, { id: item.id });
            if (res && (res.data.success || res.status === 200)) {
                swal('Deleted', 'Inquiry deleted successfully', 'success');
                fetchList();
            } else {
                swal('Error', 'Unable to delete inquiry', 'error');
            }
        } catch (error) {
            console.error('Delete error', error);
            swal('Error', 'Unable to delete inquiry', 'error');
        }
    }

    const columns = [
        { lable: 'ID', field: 'id' },
        { lable: 'Name', field: 'name' },
        { lable: 'Email', field: 'email' },
        { lable: 'Contact No', field: 'contact_no' },
        { lable: 'Message', field: 'message', truncate: 80 },
        { lable: 'Created At', field: 'created_at', },
    ];

    const wrappedData = data.map(item => ({
        ...item,
        created_at: item.created_at ? moment(item.created_at).format('YYYY-MM-DD HH:mm') : ''
    }));

    return (
        <div className='container-fluid'>
            <div className='row mt-3'>
                <div className='col-md-12'>
                    <h4>Inquiries</h4>
                    {loading ? <LoaderComponent height={80} width={80} /> : (
                        <TableComponent
                            columns={columns}
                            data={wrappedData}
                            onEdit={onView}
                            onDelete={onDelete}
                            isEditBtn={true}
                            isDeleteBtn={true}
                            editBtnLabel={'View'}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

export default InquiriesListComponent;
